import React from 'react'
import { H2 } from '@berlitz/globals'
import { useIntl } from 'react-intl'
import { getMessages } from '../constants'
import { AddDay, DateInput, DayInput, DeleteDay, FindButton, StepWarning, TimeInput } from './Fields'
import Spacer from '@berlitz/spacer'
import Button from '@components/Button'
import { BulkFormField, FormDayTimeAddBox, ModalAction } from './style'
import { useFMIBulkForm } from './useFMIBulkForm'

export interface IFormModal {
  onClose: () => void
}

const FormModal: React.FC<IFormModal> = ({ onClose = () => {} }) => {
  const intl = useIntl()
  const messages = getMessages()
  const {
    values,
    dayPlaceholders,
    isDateDirty,
    maxDate,
    showWarning,
    isLastDayTimeItem,
    isAddButtonDisabled,
    isFindButtonDisabled,
    onDateChange,
    onDayChange,
    onTimeChange,
    onAddClick,
    onDeleteClick,
    onFindClick,
  } = useFMIBulkForm()

  return (
    <>
      <H2>{intl.formatMessage(messages.step1Label)}</H2>

      {showWarning() ? <StepWarning /> : null}

      <Spacer size="xs" />

      <BulkFormField className="mobile">
        <label>{intl.formatMessage(messages.formDate)}</label>
        <div>
          <DateInput
            value={values.PreferredStartDate}
            isDirty={isDateDirty}
            maxDate={maxDate}
            onChange={onDateChange}
          />
        </div>
      </BulkFormField>

      <Spacer size="xs" />

      {values.Day.map((Day, index) => {
        const isLastItem = isLastDayTimeItem(index)

        return (
          <FormDayTimeAddBox key={`Day-Modal-${index}`}>
            <BulkFormField className="mobile">
              <label>{intl.formatMessage(messages.formDay)}</label>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <DayInput index={index} value={dayPlaceholders[index]} onChange={val => onDayChange(val, index)} />

                <label>{intl.formatMessage(messages.formTime)}</label>
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <TimeInput value={Day.StartTime} onChange={val => onTimeChange(val, index)} />

                {values.Day.length > 1 ? <DeleteDay onClick={() => onDeleteClick(index)} /> : null}
              </div>
            </BulkFormField>

            {isLastItem ? <AddDay onClick={onAddClick} disabled={isAddButtonDisabled()} /> : null}
          </FormDayTimeAddBox>
        )
      })}

      <Spacer size="xxxl" />

      <ModalAction>
        <Button onClick={onClose}>{intl.formatMessage(messages.formModalCancel)}</Button>
        <FindButton
          onClick={() => {
            onFindClick()
            onClose()
          }}
          disabled={isFindButtonDisabled()}
        />
      </ModalAction>

      <Spacer size="xxxl" />
    </>
  )
}

export default FormModal
